import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { useCreateApiKeyDialog } from "./CreateApiKeyDialog.hooks";
import { CreateApiKeyResultViewModel } from "../ApiKeys.types";
import { isNullOrWhitespace } from "@common/stringOperations";

export interface ICreateApiKeyDialogProps {
    open: boolean;
    onCloseDialog: () => void;
    onCreated: (result: CreateApiKeyResultViewModel) => Promise<void> | void;
}

function CreateApiKeyDialog(props: ICreateApiKeyDialogProps) {
    const { translateString } = useTranslation();
    const { name, setName, hasError, inProgress, createApiKey } = useCreateApiKeyDialog(props);

    return (
        <DotLegalDialog
            open={props.open}
            inProgress={inProgress}
            size="sm"
            header={translateString("createApiKey")}
            buttonOkText={translateString("create")}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => createApiKey()}
            disableBackdropOnCloseIfValueChange={[name]}
        >
            <DotLegalTextField
                debounce={false}
                size="small"
                label={translateString("name")}
                value={name}
                onChange={(value) => setName(value)}
                errorText={hasError && isNullOrWhitespace(name) ? translateString("nameRequired") : undefined}
            />
        </DotLegalDialog>
    );
}

export default CreateApiKeyDialog;
